module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_ideastudy_m.084bdac67dd1acc69751798e641c4d3e.png";